import z from 'zod';

import { ShiftTypes } from '../interfaces/shift-types';
import Status from '../interfaces/status';
import { WorkTimeTypes } from '../interfaces/work-time-types';

export const TabelRowBaseDtoScheme = z.object({
	id: z.number().describe('Уникальный идентификатор'),

	user_id: z.number().nullable().optional().describe('Уникальный идентификатор сотрудника'),
	checkin_start_id: z.number().nullable().optional().describe('Уникальный идентификатор фактического начала смены'),
	checkin_end_id: z.number().nullable().optional().describe('Уникальный идентификатор фактического окончания смены'),
	section_id: z.number().nullable().optional().describe('Уникальный идентификатор участка рабочего места'),
	employee_schedule_plan_id: z
		.number()
		.nullable()
		.optional()
		.describe('Уникальный идентификатор планового расписания'),
	staffing_id: z.number().nullable().optional().describe('Уникальный идентификатор штатки'),
	shift_type: z.nativeEnum(ShiftTypes).nullable().describe('Вид смены'),
	work_time_type: z.nativeEnum(WorkTimeTypes).nullable().describe('Вид рабочего времени'),
	responsible_user_id: z.number().nullable().optional().describe('Уникальный идентификатор ответственного за запись'),

	start: z.coerce
		.date()
		.describe('Время начала работы')
		.transform(val => new Date(val))
		.nullable()
		.optional(),
	end: z.coerce
		.date()
		.describe('Время окончания работы')
		.transform(val => new Date(val))
		.nullable()
		.optional(),
	status: z.enum(Object.values(Status) as [string, ...string[]]).describe('Статус'),
	date: z.coerce.date().describe('Плановая дата'),
	duration: z.number().describe('Итоговая продожительность смены').nullable().optional(),
	comment: z.string().describe('Комментарий'),
	expired: z.boolean().describe('За пределами периода табелирования'),
});
